import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { Icon, IconName } from 'palette/Icon';
import { Header, Small } from 'palette/Typography';
import { InfoBannerTheme } from './types';

import './styles/InfoBanner.scss';

type InfoBannerProps = {
    theme?: InfoBannerTheme;
    iconName?: IconName;
    title: string;
    subtitle?: string;
    className?: string;
};

export function InfoBanner({
    theme = 'info',
    iconName = 'palette_info',
    title,
    subtitle,
    className,
}: InfoBannerProps) {
    const [block, BEMElement] = BEMBlock('palette-info-banner');

    return (
        <div className={classNames(block, className)}>
            <div className={BEMElement('icon', { [theme]: theme })}>
                <Icon
                    color="black"
                    name={iconName}
                    size="medium"
                />
            </div>
            <Header
                className={BEMElement('title')}
                color="strong"
                level="6"
            >
                {title}
            </Header>
            <Small
                color="light"
            >
                {subtitle}
            </Small>
        </div>
    );
}
